import { render } from "./ProjectPublicationHistory.vue?vue&type=template&id=7dd99f9a&scoped=true"
import script from "./ProjectPublicationHistory.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistory.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistory.vue?vue&type=style&index=0&id=7dd99f9a&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd99f9a"]])

export default __exports__